import React, { useEffect, useState, useCallback, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import moment from 'moment-timezone'
/* --------------------------------------------- */
import { routeMap } from '../../route'
/* --------------------------------------------- */
import { GlobalContext } from '../../context/global.context'
import utils from '../../utils/utils'
import {
    device, size
} from '../../constants/breakpoints'
/* ---------------------------------------------------------------------------------------------------- */
// PurchaseRailItem component to display and handle purchase items.
const PurchaseRailItem = ({ storeProductId, title, images,theme, description,entitlementExpiry,appMessages, isPurchasedProduct, pricingPlans = [] }) => {

    const [availableTillFormated, updateAvailableTillFormated] = useState('')
    const { isAuthenticated, dispatch: globalDispatch } = useContext(GlobalContext)

    const history = useHistory()

    useEffect(() => {
        if (!isPurchasedProduct) return
        let formattedDate = moment(entitlementExpiry).format('MMMM Do, YYYY')
        updateAvailableTillFormated(formattedDate)
    }, [entitlementExpiry, isPurchasedProduct])

    const authenticate = useCallback((callback = null) => {
        if (!isAuthenticated) {
            globalDispatch({ type: 'SHOW_LOGIN_POPUP' })
            globalDispatch({
                type: 'LOGIN_POPUP_DETAILS',
                value: {
                    isShowCloseIcon: true,
                    onSignupClick: () => {
                        globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
                        history.push(routeMap.signup)
                    },
                    onLoginClick: () => {
                        globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
                        history.push(routeMap.login)
                    },
                    onCloseClick: () => globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
                }
            })
        } else {
            globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
            globalDispatch({
                type: 'LOGIN_POPUP_DETAILS', value: {}
            })
            if (callback) callback()
        }
    }, [globalDispatch, isAuthenticated, history])

    const handlePurchaseClick = () => {
        authenticate(() => {
            history.push(routeMap.payment.replace(':storeProductId', storeProductId))
        })
    }
    
    return (
        <PurchseRailItem {...{theme}} className={`purchase-rail-item ${isPurchasedProduct ? 'purchased-rail-item': ''}`} onClick={ !isPurchasedProduct ? handlePurchaseClick : null}>
            <div className='purchase-rail-item___img-box'>
                <ImgHolder {...{ images }} className='img-wrapper'>
                    <div ></div>
                </ImgHolder>
                <div className='price-box'>
                        <p>
                            {pricingPlans.length ? pricingPlans[0].currency : null}
                            <span>{pricingPlans.length ? pricingPlans[0].amount : null}</span>
                        </p>
                </div>
            </div>
            <div className='purchase-rail-item___text-box'>
                <h1>{title}</h1>
                <p>{description}</p>
                {isPurchasedProduct && <p className='details'>{appMessages.label_valid_until} <span>{availableTillFormated}</span></p>}
            </div>
        </PurchseRailItem>
    )
}

/* --------------------------------------------- */
const ImgHolder = styled.div`      
  ${({ images = [] }) => {
        return Object.keys(device).map((resolution) => {
            const ratio = 1.778
            const widthInPX = size[resolution]
            const heightInPX = widthInPX * (1 / ratio)
            const widthInPer = 100
            const heightInPer = widthInPer * (1 / ratio)
            let img = utils.getCloserMatchImage(widthInPX, heightInPX, images)
            if (!img & images.length > 0) img = images[0]
            /* --------------------------------------------- */
            img = img ? img.url : ''
            img = window.escape(img)
            img = img.replace(/https%3A/g, 'https:')
            img = img.replace(/http%3A/g, 'http:')
            return `
        div {
            @media ${device[resolution]} { 
                padding-top: ${heightInPer}%;
                width: ${widthInPer}%;
                background-image: url("${img}");
              }
        }
        `
        })
    }}
`

const PurchseRailItem = styled.div `
    .price-box p {
        color: ${({ theme: { body } }) => body && body.accent.primary};
    }

    .price-box p span{
        color: ${({ theme: { body } }) => body && body.text.primary};
    }

    .purchase-rail-item___text-box {
        color: ${({ theme: { body } }) => body && body.text.primary};
    }
`
/* ---------------------------------------------------------------------------------------------------- */
export default PurchaseRailItem
/* ---------------------------------------------------------------------------------------------------- */
